import { memo } from 'react';

import { CircularProgress, ListSubheader } from '@mui/material';
import MenuList from '@mui/material/MenuList';

import { useInterviewOptions } from '@providers/InterviewsProvider';
import ArchivedInterviewsAccordion from 'sidebarSelector/ArchivedInterviewsAccordion';
import { useInterviewListOptions } from 'sidebarSelector/InterviewList';

/**
 * `useInterviewListOptions` builds `MenuItem`s, because its other caller spreads them straight
 * into a `Select`. From MUI 9 a `MenuItem` throws outright if it cannot find a `MenuListContext`,
 * so these have to sit in a `MenuList` — a plain `List` renders the same `ul` but provides no
 * context, and every survey row threw into the ErrorBoundary, blanking this screen for anyone who
 * actually had a survey.
 */
const InterviewSelectionButtons = () => {
    const { loading } = useInterviewOptions();
    const { options: interviewOptions, CreateInterviewModal } = useInterviewListOptions();

    if (loading) {
        return <CircularProgress sx={{ alignSelf: 'center' }} />;
    }

    return (
        <>
            {/* Sibling rather than the `subheader` prop: `MenuList` has no such prop. */}
            <ListSubheader
                component="div"
                id="nested-list-subheader"
                sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                    color: 'text.secondary',
                    bgcolor: 'background.paper',
                }}
            >
                Your Surveys
            </ListSubheader>
            <MenuList
                sx={{ width: '100%', bgcolor: 'background.paper', alignSelf: 'center', pb: 0 }}
                aria-labelledby="nested-list-subheader"
            >
                {interviewOptions}
            </MenuList>
            <ArchivedInterviewsAccordion />
            {CreateInterviewModal}
        </>
    );
};

export default memo(InterviewSelectionButtons);
